/**
 * Copyright (C) 2018-2026 Cole Engineering Services, Inc. a By Light Company
 *
 * All Rights Reserved.
 *
 * Cole Engineering Services, Inc.: www.cesicorp.com
 *                                  2750 Discovery Drive
 *                                  Orlando, FL 32826
 *                                  (407) 674-8300
 */

import { ManifestFile, setManifest } from '@angular-architects/module-federation';

import { KeycloakInfo } from './app/shared/models/keycloak-info';
import { setKeycloakConfig } from './app/keycloak-config';

// Fetch manifest from backend
fetch('/portal-service/api/info/module-fed')
    .catch(err => console.error(err))
    .then(async (_: Response) => {
        var manifest: ManifestFile = await _.json();
        return setManifest(manifest);
    })
    .catch(err => console.error(err))
    .then(() => fetch('/portal-service/api/info/keycloak').catch(err => console.error(err)))
    .then(async (_: Response) => {
        var keycloakInfo: KeycloakInfo = await _.json();
        setKeycloakConfig(keycloakInfo);
    })
    .then(() => import('./bootstrap'));
